import React from 'react'

interface SendIconProps extends React.SVGProps<SVGSVGElement> {
	size?: number
}

export const SendIcon: React.FC<SendIconProps> = ({ size = 16, ...props }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<g clipPath="url(#clip0_1400_4737)">
				<path
					d="M4.43101 11.0978L0.0976631 15.4312L0.569063 15.9026L4.90241 11.5692L4.43101 11.0978Z"
					fill="currentColor"
				/>
				<path
					d="M5.09738 13.7647L3.43075 15.4314L3.90215 15.9028L5.56878 14.2361L5.09738 13.7647Z"
					fill="currentColor"
				/>
				<path
					d="M1.76408 10.4314L0.097449 12.098L0.568849 12.5694L2.23548 10.9028L1.76408 10.4314Z"
					fill="currentColor"
				/>
				<path
					d="M15.7943 0.205698C15.595 0.00669797 15.3014 -0.0456354 15.0454 0.0713646L0.475351 6.74903C0.243017 6.8557 0.0940175 7.0807 0.0866842 7.33636C0.0796842 7.59203 0.215351 7.82503 0.441351 7.94437L5.42002 10.5804L8.05602 15.5594C8.17268 15.7794 8.39668 15.914 8.64468 15.914C8.65135 15.914 8.65768 15.9137 8.66435 15.9137C8.92002 15.9064 9.14502 15.7574 9.25168 15.525L15.9297 0.955031C16.0467 0.699031 15.9937 0.405031 15.7943 0.205698ZM15.323 0.677031L8.64535 15.2474L6.07668 10.395L11.5694 4.90236L11.098 4.43103L5.60502 9.9237L0.753017 7.35503L15.3244 0.674031C15.3244 0.674031 15.3244 0.674698 15.323 0.677031Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_1400_4737">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	)
}
